
























{delay} = require('src/utilities')

module.exports =
  name: 'Departure'
  components:
    Scrollfire: require('vue-scrollfire')
  data: ->
    detectingLocation: false
  methods:
    detectLocation: ->
      console.log 'detectingLocation'
      @detectingLocation = true
      delay 5000, => @detectingLocation = false


  ready: -> window.addEventListener('scroll', this.handleScroll);



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/Departure.vue